// extracted by mini-css-extract-plugin
module.exports = {"main":"DebugAlgoliaRequests_main__DCPWA"};